import { Ship } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/company";

const linkCls = "hover:text-white transition-colors";

export function Footer() {
  return (
    <footer className="bg-primary text-white/70 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="h-9 w-9 rounded-md bg-accent flex items-center justify-center">
              <Ship className="h-5 w-5 text-white" strokeWidth={1.75} />
            </span>
            <span className="font-display font-bold text-lg text-white">WaveLine</span>
          </div>
          <p className="max-w-sm text-sm leading-relaxed">
            Book coastal &amp; harbour ferry tickets across India in seconds. Reliable schedules,
            transparent fares, instant confirmation.
          </p>
        </div>
        <div>
          <p className="overline text-white/50 mb-4">Company</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className={linkCls} data-testid="footer-about">About us</Link></li>
            <li><Link to="/contact" className={linkCls} data-testid="footer-contact">Contact us</Link></li>
            <li><Link to="/" className={linkCls}>Find ferries</Link></li>
            <li><Link to="/my-bookings" className={linkCls}>My bookings</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-white/50 mb-4">Legal</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/terms" className={linkCls} data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/refund" className={linkCls} data-testid="footer-refund">Cancellation &amp; Refund</Link></li>
            <li><Link to="/privacy" className={linkCls} data-testid="footer-privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-white/50">
          © 2026 {COMPANY.brand}. Operated by {COMPANY.legal}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
